/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OccupationUpsertRequestDto
 */
export interface OccupationUpsertRequestDto {
    /**
     * Identity of the Occupation
     * @type {string}
     * @memberof OccupationUpsertRequestDto
     */
    occupationId?: string;
    /**
     * Patient's occupation
     * @type {string}
     * @memberof OccupationUpsertRequestDto
     */
    occupation: string;
}

/**
 * Check if a given object implements the OccupationUpsertRequestDto interface.
 */
export function instanceOfOccupationUpsertRequestDto(value: object): value is OccupationUpsertRequestDto {
    if (!('occupation' in value) || value['occupation'] === undefined) return false;
    return true;
}

export function OccupationUpsertRequestDtoFromJSON(json: any): OccupationUpsertRequestDto {
    return OccupationUpsertRequestDtoFromJSONTyped(json, false);
}

export function OccupationUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OccupationUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'occupationId': json['occupationId'] == null ? undefined : json['occupationId'],
        'occupation': json['occupation'],
    };
}

export function OccupationUpsertRequestDtoToJSON(json: any): OccupationUpsertRequestDto {
    return OccupationUpsertRequestDtoToJSONTyped(json, false);
}

export function OccupationUpsertRequestDtoToJSONTyped(value?: OccupationUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'occupationId': value['occupationId'],
        'occupation': value['occupation'],
    };
}

